import { createRoute, redirect } from '@tanstack/react-router';

import { rootRoute } from './rootRoute';

const VALHALLA_PREFIX = /^\/valhalla(?=\/|$)/;

// Filters out the /valhalla prefix from the URL and redirects to the path without it,
// Solves the issues with saved urls with /valhalla prefix
export const valhallaRedirectRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/valhalla/$',
	beforeLoad: ({ location }) => {
		const cleanedHref = location.href.replace(VALHALLA_PREFIX, '') || '/';

		throw redirect({
			href: cleanedHref,
			replace: true,
		});
	},
});
